'use strict';

// Constructor
var Search = function() {
  this.name = 'search';
  console.log('%s module', this.name);

};

module.exports = Search;